import { EPTemplateModule } from './types/ep-template/ep-template.module';
import { FormlyFieldButton } from './types/button/button.component';
import { LibComponent } from './lib.component';
import { CUSTOM_FORMLY_CONFIG } from './formly-add-ons-config';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { TextDirective } from './text.directive';
import { TextService } from './text.service';
import { BrowserModule } from '@angular/platform-browser';
import {
  FormlyFieldInputButton,
  FormlyFieldRadio,
  FormlyFieldIterate,
  FormlyFieldEpRadio,
  EPTemplate,
  EPText
} from './index';

export const formlyModuleForChild:ModuleWithProviders = FormlyModule.forRoot(CUSTOM_FORMLY_CONFIG);

@NgModule({
  imports: [
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    EPTemplateModule,
    formlyModuleForChild,
    FormlyBootstrapModule
  ],
  exports: [
    FormlyFieldButton,
    FormlyFieldInputButton,
    FormlyFieldRadio,
    FormlyFieldIterate,
    FormlyFieldEpRadio,
    EPTemplateModule,
    EPText,
    TextDirective
  ],
  declarations: [
    FormlyFieldButton,
    FormlyFieldInputButton,
    FormlyFieldRadio,
    FormlyFieldIterate,
    FormlyFieldEpRadio,
    EPText,
    TextDirective,
    LibComponent
  ],
  providers: [TextService]
})
export class EpsilonAxisFormModule {}
